import { Component, OnInit } from '@angular/core';
import { DocumentRequest } from '../../../../../models/api-dam/document/document-request.model';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {  NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentService } from '../../../../../services/api-dam/document/document.service';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-documenti-create',
  templateUrl: './documenti-create.component.html'
})
export class DocumentiCreateComponent implements OnInit {

  documentModel:DocumentRequest;
  formBuilder: FormGroup;
  files:File[]=[];
  filesSRC:any;
  isButtonSaveDisabled:boolean;


  acceptFileType:string[] = [
    "application/pdf",
  ]

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private documentService: DocumentService,
    private toastr: ToastrService,
  ) {
    this.initForm();
   }

  ngOnInit(): void {
    this.documentModel = new DocumentRequest();
  }


  initForm(){
    this.formBuilder = this.fb.group({
      name: ['',[Validators.required]],
      url: '',
      alt: '',
      summary: '',
      tags: '',
      copyright: '',
      filename:['',[Validators.required]],
    });
    this.isButtonSaveDisabled = false;
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  onFileDropped(event){
    this.fileChange(event);
  }

  onFileChange(event) {
    let files = event.target.files;
    this.fileChange(files);
  }

  fileChange(files){
    
    if(files && files.length) {
      this.files = files;
      let fileType = this.files[0].type;
      //controllo se il file ha un formato corretto
      let fileTypeIsCorrect = false;
      for (let obj of this.acceptFileType) {
        if(obj === fileType){fileTypeIsCorrect = true;}
      }

      if(fileTypeIsCorrect === TRUE){
        
        let reader = new FileReader();
        const [file] = files;
  
        this.formBuilder.controls['filename'].setValue(this.files[0].name);
  
        reader.readAsBinaryString(file);
        reader.onload = () => {
            this.filesSRC = reader.result;
        }
      }else{
        this.formBuilder.controls['filename'].setValue('');
        this.files = [];
      }
    }
  }

  save(){
    if(this.formBuilder.status === 'VALID'){
      this.documentModel = this.formBuilder.value;
      this.documentService.create(this.documentModel,this.files[0]).subscribe(
        (response)=>{
          if(response != null && typeof response != typeof undefined){
            this.toastr.success('Documento creato con successo', 'Crea documento');
            this.isButtonSaveDisabled = true;
            this.activeModal.close(response);
          }
        },
        (error)=>{
          console.log(error);
          this.isButtonSaveDisabled = true;
          this.toastr.error('Si ÃƒÂ¨ verificato un errore durante la creazione dell\'documento' , 'Crea documento fallita', {
            timeOut: 5000
          });
        }
      );
    }
    
  }
  cancel() {
    this.activeModal.close('CLOSE');
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

}
